import React from 'react'

const TripsWorkshops = () => (
  <article>
    <h2>Workshops</h2>

    <p>
      I will be teaching a couple of{' '}
      <a
        href="https://www.chesterzoo.org/events/capture-the-moment/"
        target="_blank"
        rel="noreferrer"
      >
        2 day advanced courses
      </a>{' '}
      with fellow pro-photographers, Cindy Miller Hopkins and Stephen Johnson at
      Chester Zoo on 16-17 September and 21-22 September 2019. There are a few
      places left.
    </p>
  </article>
)

export default TripsWorkshops
